// extracted by mini-css-extract-plugin
module.exports = {"countryPage":"singleCountry_countryPage__rzlIv"};